import { gql } from "@apollo/client";
import { GetEnforcementIntentsWhereFilter } from "./GetPendingEnforcementIntents";
import { GetCitationsWhereFilter } from "./GetCitations";

/**
 * Distinct violation_type values that actually occur on the current account's notices
 * matching $filter. Relies on enforcement.intent's existing app_user select permission,
 * which already scopes rows to payee_account_id = X-Hasura-Account-Id — no explicit
 * account where clause needed. Callers should pass the same base filter (e.g. variant
 * status filters) as the notices list itself, so the options offered here can never
 * return zero results under that same filter.
 */
export const GET_APPLICABLE_NOTICE_VIOLATION_TYPES = gql`
  query GetApplicableNoticeViolationTypes($filter: enforcement_intent_bool_exp) {
    applicableViolationTypes: enforcement_intent(
      where: $filter
      distinct_on: violation_type
      order_by: [{ violation_type: asc }]
    ) {
      violationType: violation_type
    }
  }
`;

/**
 * Distinct violation_type values that actually occur on the current account's citations
 * matching $filter. Relies on enforcement.citation's existing app_user select permission,
 * which already scopes rows to payee_account_id = X-Hasura-Account-Id — no explicit
 * account where clause needed. Callers should pass the same base filter (e.g.
 * notice_sent_at) as the citations list itself, so the options offered here can never
 * return zero results under that same filter.
 */
export const GET_APPLICABLE_CITATION_VIOLATION_TYPES = gql`
  query GetApplicableCitationViolationTypes($filter: enforcement_citation_bool_exp) {
    applicableViolationTypes: enforcement_citation(
      where: $filter
      distinct_on: violation_type
      order_by: [{ violation_type: asc }]
    ) {
      violationType: violation_type
    }
  }
`;

export interface GetApplicableViolationTypesData {
  applicableViolationTypes: { violationType: string }[];
}

export interface GetApplicableViolationTypesVars {
  filter?: GetEnforcementIntentsWhereFilter | GetCitationsWhereFilter;
}
